import React, { Component } from 'react';

import { StringUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Header } from '../components';
import '../css/SignIn.css';

class SubscriptionInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderSubscriptionInfo = () => {
    let subscription = this.props.subscription;

    let teletails_sub = subscription.subscription;
    let stripe_sub    = subscription.stripe_subscription;
    let customer      = subscription.customer;
    let plan          = stripe_sub && stripe_sub.items && stripe_sub.items.data && stripe_sub.items.data[0] && stripe_sub.items.data[0].plan ? stripe_sub.items.data[0].plan : {};
    let amount        = plan && plan.amount   ? plan.amount   : null;
    let interval      = plan && plan.interval ? plan.interval : '';
    let is_per_year   = interval && interval === 'year';
    let plan_label    = this.getPlanLabel(teletails_sub);
    let rate_interval = is_per_year ? ' / year' : ' / month';
    let rate_string   = StringUtils.displayMoney(amount) + rate_interval;
    let last_4_str    = customer && customer.last4 ? customer.last4 : 'No Card Added';

    return <div className="standard-container">
      <Header title='TeleTails Subscription Status'
              icon='fas fa-sync-alt'
              button_title='Edit'
              button_action={ () => {
                this.props.practiceActions.openSubscriptionDetails()
              }} />
      <div className="flex-container flex-container-column" style={{ padding: 15, paddingTop: 15 }}>

        <span style={{ fontSize: 13, color: 'grey' }}>Subscription Plan: <span style={{ color: 'grey' }}>{ plan_label }</span></span>
        <span style={{ fontSize: 13, color: 'grey' }}>Rate: <span style={{ color: 'grey' }}>{ rate_string }</span></span>
        <span style={{ fontSize: 13, color: 'grey' }}>Card: <span style={{ color: 'grey' }}>{ ' **** - ' + last_4_str  }</span></span>

      </div>
    </div>
  }

  render() {
    if (this.props.hide) {
      return null;
    }
    return this.renderSubscriptionInfo();
  }

  getPlanLabel = (subscription) => {
    let subscription_type = subscription && subscription.subscription_type ? subscription.subscription_type : '';
    let label = '';

    let label_dict = {
      'INSTANT': 'Instant',
      'INSTANT_PAID': 'Instant+',
      'CORE': 'Professional',
      'ENTERPRISE': 'Enterprise'
    }

    label = label_dict[subscription_type];
    return label;
  }

}

export default SubscriptionInfo
